import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/Layout';
import DatePicker from 'react-datepicker';
import { authdApiRequest } from '../utils/api';
import 'react-datepicker/dist/react-datepicker.css';

function SnapshotForm() {
  const { id } = useParams();
  const [title, setTitle] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSnapshot = async () => {
      if (id) {
        try {
          const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/${id}`);
          const snapshotData = await response.json();
          setTitle(snapshotData.title || '');
          setStartDate(new Date(snapshotData.startDate));
          setEndDate(new Date(snapshotData.endDate));
        } catch (error) {
          console.error('Error fetching snapshot:', error);
          toast.error('Failed to load snapshot data.');
        }
      }
    };

    fetchSnapshot();
  }, [id]);

  useEffect(() => {
    const formattedStartDate = new Date(startDate).toLocaleDateString();
    const formattedEndDate = new Date(endDate).toLocaleDateString();
    const displayTitle = `${title} (${formattedStartDate} - ${formattedEndDate})`;
    document.title = id ? `Edit Snapshot - ${displayTitle} - DevWing` : 'Create New Snapshot - DevWing';
  }, [id, title, startDate, endDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const method = id ? 'PUT' : 'POST';
    const url = id ? `${process.env.REACT_APP_API_HOST}/surveys/${id}` : `${process.env.REACT_APP_API_HOST}/surveys`;

    try {
      await authdApiRequest(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title,
          startDate,
          endDate,
        }),
      });
      toast.success(`Snapshot ${id ? 'updated' : 'created'} successfully!`);
      navigate('/snapshots');
    } catch (error) {
      console.error('Error saving snapshot:', error);
      toast.error('Failed to save snapshot.');
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl mb-8 font-bold">{id ? 'Edit Snapshot' : 'Create Snapshot'}</h1>
      <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
        <input
          type="text"
          placeholder="Snapshot Title (Optional)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="p-2 border"
        />
        <div className="flex justify-center items-center">
          <div>
            <div><label>Start Date:</label></div>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                setStartDate(date);
                if (endDate && date >= endDate) {
                  setEndDate(new Date(date.getTime() + 24 * 60 * 60 * 1000)); // Set end date to one day after start date
                }
              }}
              minDate={new Date()}
              className="p-2 border bg-neutral-900 text-white"
              inline
            />
          </div>
          <div className='px-4'>to</div>
          <div>
            <div><label>End Date:</label></div>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              minDate={startDate ? new Date(startDate.getTime() + 24 * 60 * 60 * 1000) : new Date()}
              className="p-2 border bg-neutral-900 text-white"
              inline
            />
          </div>
        </div>
        <button type="submit" className="mt-8 p-2 bg-sky-500 text-white rounded-md">
          {id ? 'Update Snapshot' : 'Create Snapshot'}
        </button>
      </form>
    </Layout>
  );
}

export default SnapshotForm;
